import { ca } from '@cian/analytics';
import { useCallback, useMemo } from 'react';
import { EProgramType } from '../../../types/mortgage/programType';

export const useAnalytics = () => {
  const trackMortgageButtonClick = useCallback(() => {
    trackMortgageAnalytics({
      el: 'Mortgage_calculator_banner',
    });
  }, []);

  const trackMortgageProgramClick = useCallback((programId: EProgramType) => {
    trackMortgageAnalytics({
      el: 'Mortgage_calculator_program',
      products: [{ id: programId }],
    });
  }, []);

  const trackNoOfferClick = useCallback(() => {
    trackMortgageAnalytics({
      el: 'Mortgage_calculator_no_offer',
    });
  }, []);

  const trackMortgageModalButtonClick = useCallback((programId: EProgramType) => {
    trackMortgageAnalytics({
      el: 'Mortgage_modal',
      products: [{ id: programId }],
    });
  }, []);

  const trackMortgageOnlineLabelClick = useCallback((programId: EProgramType) => {
    trackMortgageAnalytics({
      el: 'Mortgage_calculator_program_label',
      products: [{ id: programId }],
    });
  }, []);

  return useMemo(
    () => ({
      trackMortgageButtonClick,
      trackMortgageProgramClick,
      trackNoOfferClick,
      trackMortgageModalButtonClick,
      trackMortgageOnlineLabelClick,
    }),
    [
      trackMortgageButtonClick,
      trackMortgageModalButtonClick,
      trackMortgageProgramClick,
      trackNoOfferClick,
      trackMortgageOnlineLabelClick,
    ],
  );
};

interface ITrackingData {
  el: string;
  products?: { id: EProgramType }[];
}

function trackMortgageAnalytics(data: ITrackingData) {
  ca('eventSite', {
    ec: 'CSP',
    ea: 'Click',
    ...data,
  });
}
